module.exports = __webpack_public_path__ + "static/media/logo.f7477c4a.png";